import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { StoreProvider, useStore } from "./context/StoreContext";
import Layout from "./components/Layout";
import { ReminderNotifier } from "./components/BillReminders";
import AutoLock from "./components/AutoLock";
import ReceiptInbox from "./pages/ReceiptInbox";
import { SnapFab } from "./components/SnapReceipt";
import Privacy from "./pages/Privacy";
import LockScreen from "./components/LockScreen";
import Dashboard from "./pages/Dashboard";
import Upload from "./pages/UploadBatch";
import Transactions from "./pages/Transactions";
import Budget from "./pages/Budget";
import Bills from "./pages/Bills";
import Debt from "./pages/Debt";
import Goals from "./pages/Goals";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Help from "./pages/Help";
import PageTips from "./components/PageTips";
import WhatsNew from "./components/WhatsNew";

function Shell() {
  const { status, state } = useStore();
  if (status === "loading") return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="app-loading">Opening your budget…</div>;
  if (status === "locked") return <LockScreen />;
  if (!state) return null;
  return (
    <Layout>
      <ReminderNotifier />
      <AutoLock />
      <SnapFab />
      <WhatsNew />
      <PageTips />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/budget" element={<Budget />} />
        <Route path="/bills" element={<Bills />} />
        <Route path="/debt" element={<Debt />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/privacy" element={<Privacy />} />
        <Route path="/receipts" element={<ReceiptInbox />} />
        <Route path="/help" element={<Help />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Shell />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </StoreProvider>
  );
}
